import { defineMessages } from '@cookbook/solid-intl'

export const messages = defineMessages({
    learnMoreButton: {
        defaultMessage: 'Learn More',
        id: 'FooterOrganism.learnMoreButton',
    },
    legalese: {
        defaultMessage: 'Lodgr is independent and is not endorsed by, affiliated with, sponsored by, authorized by, or otherwise associated with Airbnb® or Vrbo®, or any of their respective affiliates. Airbnb® and Vrbo® are trademarks of their respective owners.',
        id: 'FooterOrganism.legalese',
    },
    linkContact: {
        defaultMessage: 'Contact',
        id: 'FooterOrganism.link.contact',
    },
    linkGeneralGettingStarted: {
        defaultMessage: 'General & Getting Started',
        id: 'FooterOrganism.link.generalGettingStarted',
    },
    linkHome: {
        defaultMessage: 'Home',
        id: 'FooterOrganism.link.home',
    },
    linkHosting: {
        defaultMessage: 'Hosting',
        id: 'FooterOrganism.link.hosting',
    },
    linkIcalCalendarSyncing: {
        defaultMessage: 'iCal Calendar Syncing',
        id: 'FooterOrganism.link.icalCalendarSyncing',
    },
    linkLodgrNewsroom: {
        defaultMessage: 'Lodgr Newsroom',
        id: 'FooterOrganism.link.lodgrNewsroom',
    },
    linkLodgrPoints: {
        defaultMessage: 'Lodgr Points',
        id: 'FooterOrganism.link.lodgrPoints',
    },
    linkPricingPayments: {
        defaultMessage: 'Pricing & Payments',
        id: 'FooterOrganism.link.pricingPayments',
    },
    linkPrivacyPolicy: {
        defaultMessage: 'Privacy Policy',
        id: 'FooterOrganism.link.privacyPolicy',
    },
    linkSearchingBookings: {
        defaultMessage: 'Searching & Bookings',
        id: 'FooterOrganism.link.searchingBookings',
    },
    linkTermsConditions: {
        defaultMessage: 'Terms & Conditions',
        id: 'FooterOrganism.link.termsConditions',
    },
    platformDescription: {
        defaultMessage: 'Lodgr is part of the Scrawlr platform. Access all Scrawlr products with one account.',
        id: 'FooterOrganism.platformDescription',
    },
    scrawlrLogoAlt: {
        defaultMessage: 'Scrawlr Logo',
        id: 'FooterOrganism.scrawlrLogoAlt',
    },
    sectionFaq: {
        defaultMessage: 'FAQ',
        id: 'FooterOrganism.section.faq',
    },
    sectionLodgr: {
        defaultMessage: 'Lodgr',
        id: 'FooterOrganism.section.lodgr',
    },
})
